import React from "react";
import PropTypes from "prop-types";

import "./FormRow.css";

export function FormRow({ children, style, columns = 2, className = "" }) {
  const validColumns = [1, 2, 3, 4].includes(Number(columns))
    ? Number(columns)
    : 2;

  const rowClasses = [
    "katch-form-row",
    `katch-form-row--cols-${validColumns}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div style={style} className={rowClasses}>
      {children}
    </div>
  );
}

FormRow.propTypes = {
  children: PropTypes.node,
  columns: PropTypes.oneOf([1, 2, 3, 4]),
  className: PropTypes.string,
};
